
<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view/>

    <a-modal
        :maskClosable="false" :visible="visible" okText="现在去修改" @cancel="visible=false" @ok="onEditPassword" > 
        您的登录密码过于简单，建议您尽快修改密码。
    </a-modal>
    </div>
  </a-locale-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import {  getInfo } from '@/api/login'

  export default {
    data () {
      return {
        locale: zhCN,
        visible:false
      }
    },
    mounted () {
      const { $store } = this
      deviceEnquire(deviceType => {

        switch (deviceType) {
          case DEVICE_TYPE.DESKTOP:
            $store.commit('TOGGLE_DEVICE', 'desktop')
            $store.dispatch('setSidebar', true)
            break
          case DEVICE_TYPE.TABLET:
            $store.commit('TOGGLE_DEVICE', 'tablet')   
            $store.dispatch('setSidebar', false)
            break
          case DEVICE_TYPE.MOBILE:
          default:
            $store.commit('TOGGLE_DEVICE', 'mobile')
            $store.dispatch('setSidebar', true)
            break
        }
        console.log('deviceType', deviceType)
      })

      let tt = setInterval(() =>{
        console.log('检查弱口令')
        let that = this;
        getInfo().then(res => {
          console.log(res);
          if(res.data.password=="b43ff16996541d5959a38aab2f4e3c47"){
            that.visible = true
          }else{
            that.visible = false
            clearInterval(tt)
          }

        })
      },120000)
    },
    methods: {
      onEditPassword(){ 
        this.visible = false
        this.$router.push({ name: 'SiteSettingPassword' })
      },

    }
  }
</script>
<style>
  #app {
    .height: 100%;
  }
  .hightlight { color: #f5212d}
  .gray { color: gray}
  .cf { clear: both}
</style>